import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Upload,
  Table,
  Typography,
  message,
  Row,
  Col,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useBasePath } from "../../../components/NavigatePath";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import axios from "axios";
import UploadProfilePicture from "../../../components/UploadProfilePicture";
function ViewProfilePharmacies() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const location = useLocation();
  const dataLocation = location.state?.data;
  const [data, setData] = useState(dataLocation);
  const basePath = useBasePath();
  const hasRedirected = useRef(false);
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.user.accessToken);
  const API_URL = import.meta.env.VITE_API_URL;
  //Track edit
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAddBranchVisible, setIsAddBranchVisible] = useState(false);
  const [status, setStatus] = useState(data?.active ? "Active" : "Inactive");
  const [dataSource, setdataSource] = useState([]);
  const [imageUrl, setImageUrl] = useState(data ? data.logo : "");
  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
  useEffect(() => {
    if (data === undefined && !hasRedirected.current) {
      message.error("Data not found.");
      hasRedirected.current = true;
      navigate(`/${basePath}/pharmacies`);
    }
  }, [data, navigate, basePath]);
  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}pharmacies?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const responseBranches = await axios.get(
        `${API_URL}Branches/get-Branches?PharmacyID=${id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data) {
        setData(response.data.Pharmacy);
        // Also update the branches data source
        setdataSource(responseBranches.data.Branches);
      } else {
        message.error("Pharmacy data not found.");
      }
    } catch (error) {
      console.error("Error fetching pharmacy data:", error);
      message.destroy();
      message.error("Failed to load pharmacy data.");
    }
  };
  const handleAddBranch = () => {
    navigate(`/${basePath}/pharmacies/AddBranch/${data.id}`, {
      state: { data: data },
    });
  };
  // status branches
  const handleStatusChange = async (id, isActive) => {
    const status = isActive ? 1 : 0;
    try {
      // Update the status of the branch
      const response = await axios.patch(
        `${API_URL}Branches/?id=${id}`,
        { active: status },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status == 200) {
        fetchData();
        message.success("Status updated successfully for branch ");
      } else {
        message.error("Failed to update status for branch.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, API_URL, accessToken]); // Removed data from dependencies

  // Handle Edit/Save button click
  const handleEditClick = () => {
    if (isEditMode) {
      form
        .validateFields()
        .then((values) => {
          // Create an object to store the updated fields
          const updatedFields = {};

          // Check top-level fields
          const topLevelFields = ["startDate", "endDate"];
          topLevelFields.forEach((field) => {
            const value = dayjs(values[field]).startOf("day").toISOString();
            const dataValue = dayjs(data[field]).startOf("day").toISOString();

            if (value !== dataValue) {
              updatedFields[field] = values[field];
            }
          });
          console.log(data.adminDetails);
          console.log(values);

          // Check adminDetails fields
          if (data.adminDetails == null || data.adminDetails == undefined) {
            updatedFields.firstName = values.firstName;
            updatedFields.lastName = values.lastName;
            updatedFields.mobileNumber = values.mobileNumber;
          } else {
            if (values) {
              const adminNumberFields = ["mobileNumber"];
              adminNumberFields.forEach((field) => {
                if (values[field] !== data.adminDetails[field]) {
                  // console.log("in data : ",data.adminDetails[field])
                  updatedFields[field] = values[field];
                }
              });
              const adminDetailsFields = ["firstName", "lastName"];
              adminDetailsFields.forEach((field) => {
                if (values[field] !== data.adminDetails.userDetails[field]) {
                  updatedFields[field] = values[field];
                }
              });
            }
          }
          const payload = {
            adminFirstName: updatedFields.firstName,
            adminLastName: updatedFields.lastName,
            adminContactNumber: updatedFields.mobileNumber,
            startDate: updatedFields.startDate,
            endDate: updatedFields.endDate,
          };
          if (imageUrl) {
            payload.logo = imageUrl;
          }

          // Check if there are any actual changes to submit
          const hasChanges = Object.keys(updatedFields).length > 0 || (imageUrl && imageUrl !== data.logo);

          if (hasChanges) {
            axios
              .patch(`${API_URL}pharmacies?id=${data.id}`, payload, {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              })
              .then((response) => {
                console.log("Updated successfully:", response.data);
                setIsEditMode(false); // Exit edit mode
                setImageUrl("");
                setIsAddBranchVisible(true);
                message.success("Pharmacy updated");
                navigate(-1);
              })
              .catch((error) => {
                message.error(error?.response.data.message);
                console.error("Update failed:", error);
              });
          } else {
            setIsEditMode(false);
            message.info("No changes made");
          }
        })
        .catch((error) => {
          console.error("Validation failed:", error);
        });
    } else {
      setIsEditMode(true);
      setIsAddBranchVisible(true);
    }
  };

  const handleViewClick = (data) => {
    console.log(data);
    navigate(`/${basePath}/pharmacies/ViewBranch/${data.id}`, {
      state: { data: data },
    });
  };
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${API_URL}Branches/?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 200) {
        fetchData();
        message.success("Branch deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting Branch:", error);
      message.destroy();
      message.error("Failed to delete Branch");
    }
  };

  const columns = [
    {
      title: <span>Branch </span>,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (text) => (
        <span>{new Date(text).toISOString().slice(0, 10)}</span>
      ),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text) => (
        <span>{new Date(text).toISOString().slice(0, 10)}</span>
      ),
    },
    {
      title: "Profile",
      dataIndex: "Profile",
      render: (text, row) => (
        <div className="row-actions">
          <Button
            style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
            onClick={() => handleViewClick(row)}
          >
            View
          </Button>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (text, row) => (
        <div className="flex">
          <Button
            disabled={row.active}
            style={{
              borderRadius: 0,
              border: 0,
              margin: 0,
              backgroundColor: row.active ? "#3371EB" : "#F7F8FF",
              color: row.active ? "#FFFFFF" : "#123288",
              cursor: row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, true)}
          >
            Active
          </Button>
          <Button
            disabled={!row.active}
            style={{
              borderRadius: 0,
              margin: 0,
              border: 0,
              backgroundColor: row.active ? "#F7F8FF" : "#3371EB",
              color: row.active ? "#123288" : "#FFFFFF",
              cursor: !row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, false)}
          >
            Inactive
          </Button>
        </div>
      ),
    },
  ];

  if (userType === 1) {
    columns.push({
      title: "Delete",
      key: "delete",
      render: (text, row) => (
        <Button
          danger
          style={{
            borderRadius: 0,
            borderColor: "#FF4D4F",
            backgroundColor: "#FF4D4F",
            color: "#FFFFFF",
          }}
          onClick={() => handleDelete(row.id)}
        >
          Delete
        </Button>
      ),
    });
  }
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        style={{ width: "100%" }}
        initialValues={{
          startDate: dayjs(data?.startDate),
          endDate: dayjs(data?.endDate),
          mobileNumber: data?.adminDetails?.mobileNumber,
          firstName: data?.adminDetails?.userDetails?.firstName,
          lastName: data?.adminDetails?.userDetails?.lastName,
        }}
      >
        <div className="flex flex-row items-center font-semibold mb-4 text-lg md:text-xl lg:text-2xl">
          Profile -
          <span className="font-normal ml-2 md:ml-4">
            {data ? data.name : null}
          </span>
        </div>
        <div className="flex flex-col bg-white p-4 md:p-6 lg:p-10 rounded-sm">
          <Row gutter={[16, 16]} className="w-full">
            <Col xs={24} sm={24} md={6} lg={5} xl={4} className="flex flex-col items-center space-y-4 md:space-y-6">
              <UploadProfilePicture
                disabled={!isEditMode}
                value={data ? imageUrl : null}
                onChange={(url) => {
                  setImageUrl(url);
                }}
              />

              <div className="flex flex-row items-center space-x-2 md:space-x-4">
                <img src="/assets/images/phone-call.svg" alt="" className="w-5 h-5" />
                <p className="text-base md:text-lg lg:text-xl">{data ? data.contactNumber : null}</p>
              </div>
            </Col>
            <Col xs={24} sm={24} md={18} lg={19} xl={20}>
              <div className="flex flex-col space-y-3 md:space-y-5">
                <div className="flex flex-col sm:flex-row justify-between gap-2 md:gap-4">
                  <div className="flex flex-row items-center space-x-2">
                    <p className="text-sm md:text-base">Activity status</p>
                    <div
                      className={`p-1 md:p-2 ${status === "Active"
                        ? "bg-[#E8FAE9] text-[#14CC26]"
                        : "bg-[#F8D7DA] text-[#FF0000]"
                        }`}
                    >
                      <p>{status}</p>
                    </div>
                  </div>

                  <Button
                    style={{
                      color: isEditMode ? "white" : "#3371EB",
                      borderColor: "#3371EB",
                      backgroundColor: isEditMode ? "#3371EB" : null,
                    }}
                    className="py-2 px-4 md:py-3 md:px-6 lg:py-4 lg:px-10 text-sm lg:text-base"
                    onClick={handleEditClick}
                  >
                    {isEditMode ? "Save" : "Edit"}
                  </Button>
                </div>

                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Contract Start Date
                        </span>
                      }
                      name="startDate"
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%" }}
                        className="h-9 md:h-10"
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Contract End Date
                        </span>
                      }
                      name="endDate"
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%" }}
                        className="h-9 md:h-10"
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Pharmacy Admin First Name
                        </span>
                      }
                      name="firstName"
                    >
                      <Input
                        disabled={!isEditMode}
                        className="h-9 md:h-10"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} lg={8}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Pharmacy Admin Last Name
                        </span>
                      }
                      name="lastName"
                    >
                      <Input
                        disabled={!isEditMode}
                        className="h-9 md:h-10"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Admin Contact Number
                        </span>
                      }
                      name="mobileNumber"
                      rules={[
                        {
                          pattern: /^[0-9]{11}$/,
                          message: "Contact number must be exactly 11 digits",
                        },
                      ]}
                    >
                      <Input
                        className="no-arrows h-9 md:h-10"
                        maxLength={11}
                        style={{ width: "100%" }}
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mt-2 md:mt-4">
                  <p className="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Branches</p>
                  <Button
                    className="py-1 px-3 md:py-2 md:px-6 lg:py-3 lg:px-8 text-sm md:text-base"
                    style={{
                      color: "#3371EB",
                      borderColor: "#3371EB",
                    }}
                    onClick={handleAddBranch}
                  >
                    + Add Branch
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          <div className="w-full mt-6 md:mt-8 lg:mt-12 overflow-x-auto">
            <Table
              className="customTable"
              style={{ backgroundColor: "#FFFFFF" }}
              columns={columns}
              dataSource={dataSource}
              rowKey="key"
              scroll={{ x: 'max-content' }}
              pagination={{ responsive: true }}
              locale={{
                emptyText: (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "300px",
                      width: "100%",
                    }}
                  >
                    <Typography.Text
                      className="text-xl md:text-2xl lg:text-3xl"
                      style={{
                        color: "#C0D3F9",
                        fontWeight: 400,
                      }}
                    >
                      No available branches
                    </Typography.Text>
                  </div>
                ),
              }}
            />
          </div>
        </div>
      </Form>
    </>
  );
}

export default ViewProfilePharmacies;
